<template lang="pug">
    div(style="height:100%;")
        input(ref="jlp" style="position:absolute; opacity: 0; left: -4000px; top: -4000px;")
        div.pt-1.black.white--text(style="height: 30px;")
            v-layout
                v-flex.px-3.xs4.font-weight-bold Promo
                v-flex.px-3.xs7.font-weight-bold Productos
                v-flex.xs1.font-weight-bold Precio
        div(style="height: calc(100% - 60px); overflow: scroll;")
            v-list
                template(v-for="(item, idx) in currentList")
                    v-list-tile(style="overflow:hidden;")
                        v-btn.text-sm-left.px-3.tile(
                            style="width:100%" 
                            :class="{ 'indigo': hoverIdx === idx, 'darken-4': hoverIdx === idx, 'white--text': hoverIdx === idx }"
                            @click="addToCart(item.id)"
                        )
                            v-layout(@mouseover="hoverIdx = idx" row)
                                v-flex.xs4
                                    div.item-upc
                                        span {{item.name}}
                                        span.caption UPC: {{item.upc_code}}
                                v-divider(vertical)
                                v-flex.xs7 
                                    span(v-for="(product, idx) in item.composition.composition")
                                        span {{product.quantity}} {{product.item_name}} 
                                        span(v-if="item.composition.composition.length != idx + 1") + 
                                v-divider(vertical)
                                v-flex.xs1
                                    span {{item.sale_price | mixFormatCurrency}}
                    v-divider
        div.pagination.black.wite--text.text-sm-center
            v-pagination(:length="pagination ? pagination.lastPage : 0" :total-visible="5" v-model="page")
        
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import helper from '@/services/API/helpers/ProductHelper.js'
import { findByKey, find } from '@/services/API/ProductService.js'
export default {
    name: 'promo-list',
    props: {},
    data: function() {
        return {
            hoverIdx: null,
            page: 1,
        }
    },
    computed: {
        ...mapState('PromoModule', {
            currentList: 'currentList',
            model: 'model',
            pagination: 'pagination',
        }),
    },
    methods: {
        ...mapActions('PromoModule', {
            setPagination: 'setPagination',
            setCurrentList: 'setCurrentList',
        }),
        ...mapActions('CartModule', {
            addItemToCart: 'addItemToCart',
        }),
        addToCart: async function(id) {
            const item = await find(id)
            if (item) this.addItemToCart(item)
        },
    },
    watch: {
        /**
         * @description
         */
        page: async function(newVal, oldVal) {
            let data = await this.model.page(newVal).get()
            let pagination = this.pagination
            pagination.currentPage = data.current_page
            this.setPagination(pagination)
            this.setCurrentList(helper.frontendProductsArray(data.data))
        },
    },
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){},
    beforeMount: function() {
        if (this.pagination && this.pagination.currentPage)
            this.page = this.pagination.currentPage
    },
    mounted: function() {
        this.$nextTick(() => this.$refs.jlp.focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.item-upc {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: center;
    overflow: hidden;
}
.item-promo {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
}
.v-list > div,
.tile {
    transition: none;
}
.tile {
    cursor: pointer;
}
.tile:active {
    background-color: rgb(66, 66, 224);
}
.display-area {
    overflow: hidden !important;
}
.pagination {
    margin-top: -10px;
}
</style>
